import React from "react";

const AnchoredPortalContext = React.createContext(null);

export default AnchoredPortalContext;
